import lazyLoading from '../lazyLoading'
import loader from '../loader'

import config from '../../../app.config'

import listRoutes from './workbench/index'
import otherListRoutes from './business-name-second/index'

export default [
  {
    path: '/skl',
    redirect:'/skl/declarationCenter',
    component: lazyLoading('layout/index'),
    meta: {
      title: '工作台',
      icon:'robot',
      isFirst:true, //判断是否存在一级或者是一级
      keepAlive: true
    },
    children: listRoutes
  },
  {
    path: "/mobileUgc",
    name: 'mobileUgc',
    component: lazyLoading('views/mobile/index'),
    meta: {
      title: '数媒2050'
    }
  },
  //错误页面
  {
    path: '/600',
    name: '600',
    component: loader('views/exception/600.vue'),
    meta: {
      title: '链接已断开'
    }
  },
  {
    path: '/404',
    name: '404',
    component: loader('views/exception/404.vue'),
    meta: {
      title: '404'
    }
  },
  {
    path: '/403',
    name: '403',
    component: loader('views/exception/403.vue'),
    meta: {
      title: '403'
    }
  },
  {
    path: '/500',
    name: '500',
    component: loader('views/exception/500.vue'),
    meta: {
      title: '500'
    }
  },

  {
    path: '*',
    name: 'notFount',
    component: loader('views/exception/404.vue'),
    meta: {
      title: '该页面不存在',
    }
  },

  {
    path: "/",
    name: 'login',
    component: lazyLoading('views/login/index'),
    meta: {
      title: '登录-' + config.appTitle
    },
  },
  {
    path: "/modifyInformation",
    name: 'modifyInformation',
    component: lazyLoading('views/modifyInformation/index'),
  },
  {
    path: "/complete-information",
    name: 'complete-information',
    component: lazyLoading('views/complete-information/index'),
  },
  // {
  //   path: "/main",
  //   name: 'main',
  //   component: lazyLoading('views/main/index'),
  //   meta: {
  //     title: '登录-' + config.appTitle
  //   }
  // },
  // {
  //   path: "/version",
  //   name: 'version',
  //   component: lazyLoading('views/version/index'),
  //   meta: {
  //     title: '更新内容-' + config.appTitle
  //   }
  // }
  /* {
        path: "*",
        redirect: "/404"
    } */
];